.showcase {
  overflow: hidden;
  border: 1px solid var(--color-border);
  border-radius: var(--radius-2xl);
  background: var(--color-background);
}

.canvas {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 5rem minmax(0, 2.4fr);
  align-items: center;
  padding: 3rem 2rem;
  background-color: var(--color-surface-subtle);
  background-image: radial-gradient(var(--color-border) 1px, transparent 1px);
  background-size: 20px 20px;
}

.source {
  margin: 0;

  figcaption {
    display: flex;
    flex-direction: column;
    gap: 0.375rem;
    margin-top: 1.25rem;
    text-align: center;
  }
}

.original,
.picture {
  display: block;
  overflow: hidden;
  border-radius: var(--radius-md);
  box-shadow: 5px 6px 0 var(--color-primary-border);
}

.original {
  aspect-ratio: 3 / 2;
  border: 5px solid var(--color-background);
}

.connection {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--color-primary);
  margin-bottom: 4rem;

  &::before {
    content: "";
    position: absolute;
    inset-inline: 0;
    height: 2px;
    background: var(--color-primary-border);
  }

  > svg {
    position: absolute;
    inset-inline-end: 0;
  }
}

.outputs {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 0.75rem;
}

.outputs .output {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  min-width: 0;
  padding: 1rem 0.75rem;
  border: 1px solid transparent;
  border-radius: var(--radius-lg);
  color: var(--color-foreground);
  white-space: normal;

  &[data-active] {
    border-color: var(--color-primary-border);
    background: var(--color-background);
    box-shadow: var(--shadow-sm);
  }
}

.preview {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  aspect-ratio: 1;
  margin-bottom: 1rem;
}

.picture {
  flex-shrink: 0;
}

.scene {
  display: block;
  width: 100%;
  height: 100%;

  svg {
    display: block;
  }
}

.outputLabel {
  font-weight: 600;
}

.dimensions {
  font: 0.75rem / 1.5 var(--font-mono);
}

.controls,
.caption {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding: 1.25rem 1.5rem;
}

.controls {
  min-width: 0;
  margin: 0;
  border: 0;
  border-block: 1px solid var(--color-border);
}

.effects {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;

  svg {
    width: 1rem;
    height: 1rem;
  }
}

.caption {
  gap: 0.5rem 1.5rem;
}

@media (max-width: 800px) {
  .canvas {
    grid-template-columns: 1fr;
    padding: 2rem 1rem 1rem;
  }

  .source {
    width: min(55%, 15rem);
    justify-self: center;
  }

  .connection {
    height: 4.5rem;
    margin: 0;

    &::before {
      width: 2px;
      height: 100%;
      inset-inline: auto;
    }

    > svg {
      display: none;
    }
  }
}

@media (max-width: 480px) {
  .outputs {
    gap: 0.25rem;
  }

  .outputs .output {
    padding: 0.75rem 0.25rem;
  }

  .dimensions {
    font-size: 0.625rem;
  }

  .controls,
  .caption {
    padding: 1rem;
  }
}
